import React from "react";
import { WifiOff } from "lucide-react";

import { useNetworkStatus } from "src/contexts/NetworkStatusContext";

// Persistent banner shown while the browser is offline. Renders nothing when
// online. Mirrors ImpersonationBanner's sticky/top/high-z-index pattern; amber
// (vs impersonation's red) to read as a warning rather than an alert.
export default function OfflineBanner() {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      role="status"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9998,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
        padding: "0.5rem 1rem",
        background: "#b45309",
        color: "#fff",
        fontSize: "0.875rem",
        fontWeight: 600,
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
      }}
    >
      <WifiOff size={16} aria-hidden="true" />
      <span>You're offline. Some actions are paused until your connection is restored.</span>
    </div>
  );
}
